// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIgnoreElectionLimitPropertyDto
 */
export interface IIgnoreElectionLimitPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIgnoreElectionLimitPropertyDto
     */
    ignore_election_limit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIgnoreElectionLimitPropertyDto
     */
    ignore_election_limit_state?: IIgnoreElectionLimitPropertyDtoIgnoreElectionLimitStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIgnoreElectionLimitPropertyDtoIgnoreElectionLimitStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIgnoreElectionLimitPropertyDto interface.
 */
export function instanceOfIIgnoreElectionLimitPropertyDto(value: object): value is IIgnoreElectionLimitPropertyDto {
    return true;
}

export function IIgnoreElectionLimitPropertyDtoFromJSON(json: any): IIgnoreElectionLimitPropertyDto {
    return IIgnoreElectionLimitPropertyDtoFromJSONTyped(json, false);
}

export function IIgnoreElectionLimitPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIgnoreElectionLimitPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ignore_election_limit': json['ignore_election_limit'] == null ? undefined : json['ignore_election_limit'],
        'ignore_election_limit_state': json['ignore_election_limit_state'] == null ? undefined : json['ignore_election_limit_state'],
    };
}

export function IIgnoreElectionLimitPropertyDtoToJSON(json: any): IIgnoreElectionLimitPropertyDto {
    return IIgnoreElectionLimitPropertyDtoToJSONTyped(json, false);
}

export function IIgnoreElectionLimitPropertyDtoToJSONTyped(value?: IIgnoreElectionLimitPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ignore_election_limit': value['ignore_election_limit'],
        'ignore_election_limit_state': value['ignore_election_limit_state'],
    };
}

